// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1cPZ1","modal":"Modal_modal__U5ax1","slide-down":"Modal_slide-down__3fqLa"};